import React from "react";
import { Grid, GridColumn as Column} from '@progress/kendo-react-grid';
import { LookupIncidentAssignUserGridCommand } from "./LookupIncidentAssignUserGridCommand";
import { EntraUser } from "../../../../../../../services/profileService/model/entraUser/EntraUser";


type ownProps={
    searchResults:EntraUser[];
}

function LookupIncidentAssignUserSearchResults(props:ownProps){
    return <React.Fragment>
        <Grid className="card-body-grid" data={props.searchResults} style={{height:'500px'}}>
            <Column cell={LookupIncidentAssignUserGridCommand} width={'75px'}/>
            <Column title='Name' field='displayName' width={'300px'}/>
        </Grid>
    </React.Fragment>
}

export {LookupIncidentAssignUserSearchResults}